// extracted by mini-css-extract-plugin
export default {"container":"TextBlockComponent_container__qLGXm"};